import React from 'react'
import { Button, CircularProgress } from '@material-ui/core';
import useStyles from './style';
import { chatRedirect } from '../../utils';

const FooterViewer = (props) => {
    const { saveData, isUpdated, listPages } = props;
    const { chartData, chartUniqueId } = props.data || {};
    const classes = useStyles();
    const isLoading = props.formData?.[chartUniqueId + '_update_loading'] || props.formData?.[chartUniqueId + '_save_loading'] ||  false;
    
    return (
        <div className={classes.root}>
            <Button variant="contained" className={classes.cancelButton} onClick={() => { chatRedirect(props.history, props.match.params.appid, listPages) }}>Cancel</Button>
            {isLoading ? (
                <div className={classes.loaderContainer}>
                    <CircularProgress size={24} className={classes.loader} />
                </div>
            ) : (
                <Button 
                    variant="contained" 
                    className={classes.saveButton} 
                    onClick={() => { saveData() }}
                >
                    {isUpdated ? 'Update' : 'Save'}
                </Button>
            )}
        </div>
    )
}

export default FooterViewer